// @ts-nocheck
// TypeScript is ignoring this file. If you are editing this file you must fix the type issues.

import { useTranslation } from 'react-i18next';
import { useStore } from '../../store';
import { LEGAL_DOC_TERMS_AND_CONDITIONS_CHOICE, LEGAL_DOC_TERMS_AND_CONDITIONS_SUNRISE } from '../../constants/general';
import { BANK_DEFINITION_TYPES } from '../../types';

export const useCustomerHelper = (): {
  isSunriseCustomer: boolean;
  termsAndConditionsLink: string;
  termsAndConditionsLinkTitle: string;
} => {
  const { t } = useTranslation('generalEn');
  const { getPrimaryAccount } = useStore((state) => state);
  const {
    bankInfo: { bank },
  } = getPrimaryAccount();
  const isSunriseCustomer = bank === BANK_DEFINITION_TYPES.SUNRISE;
  const termsAndConditionsLink = isSunriseCustomer
    ? LEGAL_DOC_TERMS_AND_CONDITIONS_SUNRISE
    : LEGAL_DOC_TERMS_AND_CONDITIONS_CHOICE;
  const termsAndConditionsLinkTitle = isSunriseCustomer
    ? t('TERMS_AND_CONDITIONS.SUNRISE_LINK_TITLE')
    : t('TERMS_AND_CONDITIONS.CHOICE_LINK_TITLE');

  return {
    isSunriseCustomer,
    termsAndConditionsLink,
    termsAndConditionsLinkTitle,
  };
};
